import api from '@/services/api';
import { inMgnl } from '@/helpers/AppHelpers';

export default {
  async getGamesActivities(uuid) {
    return new Promise((resolve, reject) => {
      const withCredentials = {
        withCredentials: true,
      };
      api
        .call(`activity-api/v1/customer/${uuid}/activity`, 'getGameActivity', 'GET', {
          withCredentials,
          headers: {
            // eslint-disable-next-line no-undef
            'X-nec-token': ejApi.lireCookie('neccton_token'),
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          // eslint-disable-next-line no-undef
          ejApi.ecrireCookie('neccton_token', response.data?.jwt);
          resolve(response.data.period);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  },

  async getUnreadMessagesCount(uuid) {
    return new Promise((resolve, reject) => {
      const withCredentials = {
        withCredentials: true,
      };
      api
        .call(
          `activity-api/v1/customer/${uuid}/messages/unreadMessages`,
          'getUnreadMessages',
          'GET',
          {
            withCredentials,
            headers: {
              // eslint-disable-next-line no-undef
              'X-nec-token': ejApi.lireCookie('neccton_token') ?? null,
              'Content-Type': 'application/json',
            },
          }
        )
        .then((response) => {
          // eslint-disable-next-line no-undef
          ejApi.ecrireCookie('neccton_token', response.data?.jwt);
          resolve(response.data.count);
        })
        .catch(function (error) {
          console.log(error);
          resolve(undefined);
        });
    });
  },

  async getUnreadMessages(uuid) {
    return new Promise((resolve, reject) => {
      const withCredentials = {
        withCredentials: true,
      };

      api
        .call(
          `activity-api/v1/customer/${uuid}/messages/unreadMessages`,
          'getUnreadMessages',
          'GET',
          {
            withCredentials,
            headers: {
              // eslint-disable-next-line no-undef
              'X-nec-token': ejApi.lireCookie('neccton_token'),
              'Content-Type': 'application/json',
            },
          }
        )
        .then((response) => {
          const responseData = response.data || {};
          const messages =
            responseData.message || responseData.messages || responseData.unreadMessages || [];

          // eslint-disable-next-line no-undef
          ejApi.ecrireCookie('neccton_token', responseData?.jwt);
          resolve({
            count: typeof responseData.count === 'number' ? responseData.count : messages.length,
            messages: Array.isArray(messages) ? messages : [],
          });
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  },

  async getMessages(uuid, limit, offset) {
    return new Promise((resolve, reject) => {
      const withCredentials = {
        withCredentials: true,
      };
      const data = {
        limit,
        offset,
      };
      api
        .call(`activity-api/v1/customer/${uuid}/messages`, 'getMessages', 'POST', {
          withCredentials,
          data,
          headers: {
            // eslint-disable-next-line no-undef
            'X-nec-token': ejApi.lireCookie('neccton_token') ?? null,
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          const responseData = response.data || {};
          const messages = Array.isArray(responseData.message) ? responseData.message : [];
          const usesLocalMock = process.env.VUE_APP_IS_MOCK === 'true' || inMgnl;

          // eslint-disable-next-line no-undef
          ejApi.ecrireCookie('neccton_token', responseData.jwt);
          resolve(usesLocalMock ? messages.slice(offset, offset + limit) : messages);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  },

  async setReadMessage(uuid, messageId) {
    return new Promise((resolve, reject) => {
      const withCredentials = {
        withCredentials: true,
      };
      api
        .call(`activity-api/v1/customer/${uuid}/messages/${messageId}`, 'setReadMessage', 'PUT', {
          withCredentials,
          headers: {
            // eslint-disable-next-line no-undef
            'X-nec-token': ejApi.lireCookie('neccton_token') ?? null,
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          // eslint-disable-next-line no-undef
          ejApi.ecrireCookie('neccton_token', response.data?.jwt);
          resolve('success');
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  },
};
